import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoutes';
import MarketplaceRequestsPage from '../../pages/MarketplaceRequestsPage';
import MarketplaceNewRequestPage from '../../pages/MarketplaceNewRequestPage';
import MarketplaceRequestDetailPage from '../../pages/MarketplaceRequestDetailPage';
import MarketplaceInboxPage from '../../pages/MarketplaceInboxPage';
import MarketplaceInboxDetailPage from '../../pages/MarketplaceInboxDetailPage';
import MarketplaceVerificationCallbackPage from '../../pages/MarketplaceVerificationCallbackPage';
import { isMarketplaceEnabled } from '../../utils/config';
import { CLIENT_SIGNUP_PATH } from '../../services/api/accountService';

export const MARKETPLACE_PATHS = [
  '/marketplace',
  '/marketplace/new',
  '/marketplace/requests/:leadUuid',
  '/marketplace/inbox',
  '/marketplace/inbox/:leadUuid',
  '/marketplace/verification/callback',
] as const;

/**
 * Marketplace routes for the private `<Switch>`. Returns an ARRAY (Switch
 * flattens arrays; a Fragment would be treated as a pathless catch-all) and
 * returns NOTHING when REACT_APP_MARKETPLACE_ENABLED is off, so the paths
 * fall through to the 404 like any unknown URL.
 *
 * Client: /marketplace (my requests) → /new → /requests/:uuid.
 * Lawyer: /marketplace/inbox → /inbox/:uuid; BankID returns to /verification/callback.
 */
export const getMarketplaceRoutes = (subscriptionId?: string): React.ReactElement[] => {
  if (!isMarketplaceEnabled()) return [];
  const route = (key: string, path: string, component: React.ComponentType) => (
    <PrivateRoute key={key} path={path} exact component={component} subscriptionId={subscriptionId} restricted={false} />
  );
  return [
    // The M0 skeleton's first URL - keep old links working.
    <Route key="mp-intake" exact path="/marketplace/intake">
      <Redirect to="/marketplace/new" />
    </Route>,
    // The public "Find a lawyer" link, followed by someone already signed in.
    <Route key="mp-get-help" exact path={CLIENT_SIGNUP_PATH}>
      <Redirect to="/marketplace/new" />
    </Route>,
    route('mp-requests', '/marketplace', MarketplaceRequestsPage),
    route('mp-new', '/marketplace/new', MarketplaceNewRequestPage),
    route('mp-request', '/marketplace/requests/:leadUuid', MarketplaceRequestDetailPage),
    route('mp-inbox', '/marketplace/inbox', MarketplaceInboxPage),
    route('mp-inbox-detail', '/marketplace/inbox/:leadUuid', MarketplaceInboxDetailPage),
    route('mp-verify-callback', '/marketplace/verification/callback', MarketplaceVerificationCallbackPage),
  ];
};
